import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ width: "90%", marginTop: 95 }}>
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <title>Kurr_Integritetspolicy_2023-03-08.docx</title>
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            '\n            * {\n                margin: 0;\n                padding: 0;\n                text-indent: 0;\n            }\n\n            h1 {\n                color: #002060;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: bold;\n                text-decoration: none;\n                font-size: 22pt;\n            }\n\n            h2 {\n                color: #002060;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: bold;\n                text-decoration: none;\n                font-size: 18pt;\n            }\n\n            p {\n                color: black;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 12pt;\n                margin: 0pt;\n            }\n\n            .a, a {\n                color: black;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 12pt;\n            }\n\n            h4 {\n                color: #002060;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: bold;\n                text-decoration: none;\n                font-size: 11pt;\n            }\n\n            .s3 {\n                color: black;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 11pt;\n            }\n\n            .s4 {\n                color: black;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 12pt;\n            }\n\n            .s5 {\n                color: black;\n                font-family: Arial, sans-serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 11pt;\n            }\n\n            li {\n                display: block;\n            }\n\n            #l1 {\n                padding-left: 0pt;\n            }\n\n            #l1> li>*:first-child:before {\n                content: "- ";\n                color: black;\n                font-family: Arial, sans-serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 11pt;\n            }\n\n            li {\n                display: block;\n            }\n\n            #l2 {\n                padding-left: 0pt;\n            }\n\n            #l2> li>*:first-child:before {\n                content: "- ";\n                color: black;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 12pt;\n            }\n\n            li {\n                display: block;\n            }\n\n            #l3 {\n                padding-left: 0pt;\n            }\n\n            #l3> li>*:first-child:before {\n                content: "- ";\n                color: black;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 12pt;\n            }\n\n            li {\n                display: block;\n            }\n\n            #l4 {\n                padding-left: 0pt;\n            }\n\n            #l4> li>*:first-child:before {\n                content: "- ";\n                color: black;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 12pt;\n            }\n\n            li {\n                display: block;\n            }\n\n            #l5 {\n                padding-left: 0pt;\n            }\n\n            #l5> li>*:first-child:before {\n                content: "- ";\n                color: black;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 12pt;\n            }\n\n            li {\n                display: block;\n            }\n\n            #l6 {\n                padding-left: 0pt;\n            }\n\n            #l6> li>*:first-child:before {\n                content: "- ";\n                color: black;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 12pt;\n            }\n\n            li {\n                display: block;\n            }\n\n            #l7 {\n                padding-left: 0pt;\n            }\n\n            #l7> li>*:first-child:before {\n                content: "- ";\n                color: black;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 12pt;\n            }\n\n            li {\n                display: block;\n            }\n\n            #l8 {\n                padding-left: 0pt;\n            }\n\n            #l8> li>*:first-child:before {\n                content: "- ";\n                color: black;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 12pt;\n            }\n\n            li {\n                display: block;\n            }\n\n            #l9 {\n                padding-left: 0pt;\n            }\n\n            #l9> li>*:first-child:before {\n                content: "- ";\n                color: black;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 12pt;\n            }\n\n            li {\n                display: block;\n            }\n\n            #l10 {\n                padding-left: 0pt;\n            }\n\n            #l10> li>*:first-child:before {\n                content: "- ";\n                color: black;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 12pt;\n            }\n\n            li {\n                display: block;\n            }\n\n            #l11 {\n                padding-left: 0pt;\n            }\n\n            #l11> li>*:first-child:before {\n                content: "- ";\n                color: black;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 12pt;\n            }\n\n            li {\n                display: block;\n            }\n\n            #l12 {\n                padding-left: 0pt;\n            }\n\n            #l12> li>*:first-child:before {\n                content: "- ";\n                color: black;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 12pt;\n            }\n\n            li {\n                display: block;\n            }\n\n            #l13 {\n                padding-left: 0pt;\n            }\n\n            #l13> li>*:first-child:before {\n                content: "- ";\n                color: black;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 12pt;\n            }\n\n            li {\n                display: block;\n            }\n\n            #l14 {\n                padding-left: 0pt;\n            }\n\n            #l14> li>*:first-child:before {\n                content: "- ";\n                color: black;\n                font-family: "Times New Roman", serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 12pt;\n            }\n\n            #l15 {\n                padding-left: 0pt;\n            }\n\n            #l15> li>*:first-child:before {\n                content: "● ";\n                color: black;\n                font-family: Arial, sans-serif;\n                font-style: normal;\n                font-weight: normal;\n                text-decoration: none;\n                font-size: 10pt;\n            }\n\n            table, tbody {\n                vertical-align: top;\n                overflow: visible;\n            }\n        ',
        }}
      />
      <h1
        style={{
          paddingTop: "2pt",
          paddingLeft: "6pt",
          textIndent: "0pt",
          lineHeight: "155%",
          textAlign: "left",
        }}
      >
        Information om behandling av personuppgifter{" "}
      </h1>
      <h1
        style={{
          paddingTop: "2pt",
          paddingLeft: "6pt",
          textIndent: "0pt",
          lineHeight: "155%",
          textAlign: "left",
          color: "#F00",
        }}
      >
        Kurr AB 559345-2922
      </h1>
      {/* <span style={{ color: "#F00" }}>Kurr AB 559345-292</span> */}
      <h2
        style={{
          paddingLeft: "6pt",
          textIndent: "0pt",
          lineHeight: "20pt",
          textAlign: "left",
        }}
      >
        Allmänt
      </h2>
      <p
        style={{
          paddingTop: "14pt",
          paddingLeft: "6pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        På Kurr AB arbetar vi hårt för att tjäna våra kunder, samhällen och vår
        planet lite bättre varje dag. För att kunna göra detta måste vi kunna
        erbjuda dig produkter och tjänster som uppfyller dessa mål. Att ta hand
        om de uppgifter du delar med oss är en enormt viktig del av detta. Vi
        vill att du ska känna dig trygg med att dina uppgifter är säkra hos oss
        och att du förstår hur vi använder dem för att erbjuda dig en bättre,
        hållbarare och mer personlig upplevelse när du och ditt hushåll
        bestämmer vad ni ska äta.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
        Nedan beskrivs hur <b>Kurr AB </b>
        (”<b>Kurr</b>
        ”, ”<b>vi</b>
        ”, ”<b>vår</b>
        ”, ”<b>oss</b>
        ”) behandlar dina personuppgifter i samband med att du besöker vår
        webbplats eller app, nyttjar våra tjänster eller när vi på annat sätt
        behandlar dina uppgifter<span style={{ color: "#333" }}>.</span>
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <h2 style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
        Personuppgiftsansvarig
      </h2>
      <p style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
        Kurr är personuppgiftsansvarig för behandling av dina personuppgifter i
        samband med att vi tillhandahåller våra tjänster till dig. Du når oss
        enligt följande:
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
        Kurr AB Skolgatan 115 B
      </p>
      <p
        style={{
          paddingLeft: "6pt",
          textIndent: "0pt",
          lineHeight: "200%",
          textAlign: "left",
        }}
      >
        <a href="mailto:privacy@kurr.co" className="a" target="_blank">
          903 32 Umeå{" "}
        </a>
        <a href="mailto:privacy@kurr.co" target="_blank">
          privacy@kurr.co
        </a>
      </p>
      <h2 style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
        Hur samlar vi in och behandlar dina uppgifter?
      </h2>
      <p
        style={{
          paddingLeft: "6pt",
          textIndent: "0pt",
          textAlign: "justify",
        }}
      >
        När du interagerar med oss online (t. ex. via vår hemsida eller
        applikation), registrerar dig eller kommunicerar med oss samlar vi in,
        behandlar och skapar även nya personuppgifter om dig. Vår viktigaste
        källa till personuppgifter är när du lämnar information om dig själv i
        samband med att du blir registrerad användare eller i andra kontakter du
        har med oss. Exempel på personuppgifter som vi behandlar är namn,
        e-postadress och mobiltelefonnummer. Även mer specifik information kan
        dock komma att samlas in och behandlas när du anger ditt kön, din diet
        eller dina matpreferenser. Likaså kan ditt användarbeteende och dina
        personuppgifter även komma att sparas och behandlas. Dina
        personuppgifter kan komma att analyseras på en aggregerad nivå.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <h2 style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
        Definitionslista
      </h2>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingLeft: "6pt",
          textIndent: "0pt",
          lineHeight: "108%",
          textAlign: "left",
        }}
      >
        Följande termer används i denna integritetspolicy, och är i enlighet med
        gällande dataskyddslagstiftning:
      </p>
      <h4
        style={{
          paddingTop: "3pt",
          paddingLeft: "6pt",
          textIndent: "0pt",
          textAlign: "justify",
        }}
      >
        Personuppgift{" "}
        {/* <span className="s3">
          Personuppgifter är all information som kan användas för att, direkt
        </span> */}
      </h4>
      <p
        className="s3"
        style={{
          paddingLeft: "100pt",
          textIndent: "0pt",
          textAlign: "justify",
        }}
      >
        Personuppgifter är all information som kan användas för att, direkt
        eller indirekt, identifiera en levande person. Till exempel användares
        e-postadresser, matpreferenser, interaktioner och kommentarer, kunders
        finansiella information, uppgifter om anställda eller statistik över
        webbplatsanvändare.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <h4
        style={{
          paddingLeft: "6pt",
          textIndent: "0pt",
          textAlign: "justify",
        }}
      >
        Registrerad{" "}
        {/* <span className="s3">
          Den person som kan bli identifierade genom personuppgifterna, är
        </span> */}
      </h4>
      <p
        className="s3"
        style={{
          paddingLeft: "100pt",
          textIndent: "0pt",
          textAlign: "justify",
        }}
      >
        Den person som kan bli identifierade genom personuppgifterna, är enligt
        GDPR benämnd som en ’registrerad’.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <h4
        style={{
          paddingLeft: "150pt",
          textIndent: "-144pt",
          textAlign: "justify",
        }}
      >
        Användare{" "}
        {/* <span className="s3">
          En användare är en besökare på vår webbplats eller applikation, som
          antingen har registrerat sig som användare av våra tjänster eller är
          en unik besökare som besöker oss en eller flera gånger. I båda fallen
          behandlar vi användaren som en Registrerad.
        </span> */}
      </h4>
      <p
        className="s3"
        style={{
          paddingLeft: "100pt",
          textIndent: "0pt",
          textAlign: "justify",
        }}
      >
        En användare är en besökare på vår webbplats eller applikation, som
        antingen har registrerat sig som användare av våra tjänster eller är en
        unik besökare som besöker oss en eller flera gånger. I båda fallen
        behandlar vi användaren som en Registrerad.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <h4
        style={{
          paddingLeft: "150pt",
          textIndent: "-144pt",
          textAlign: "justify",
        }}
      >
        Kreatör{" "}
        {/* <span className="s3">
          En kreatör på vår webbsida eller i vår applikation är en användare som
          skapar och delar med sig av recept (inklusive ingredienser,
          steg-för-steg, video och bild) öppet på plattformen.. Det som skiljer
          ett kreatörskonto från ett användarkonto är att kreatören får tillgång
          till kreatörsverktyg och -funktioner, såsom att kunna följa sina
          inlägg i flödet, samt att se hur sina receptdelningar och sina idéer
          har presterat, och på vilket sätt aktiviteter skett osv. Härutöver
          behandlas en Kreatör som en användare.
        </span> */}
      </h4>
      <p
        className="s3"
        style={{
          paddingLeft: "100pt",
          textIndent: "0pt",
          textAlign: "justify",
        }}
      >
        En kreatör på vår webbsida eller i vår applikation är en användare som
        skapar och delar med sig av recept (inklusive ingredienser,
        steg-för-steg, video och bild) öppet på plattformen.. Det som skiljer
        ett kreatörskonto från ett användarkonto är att kreatören får tillgång
        till kreatörsverktyg och -funktioner, såsom att kunna följa sina inlägg
        i flödet, samt att se hur sina receptdelningar och sina idéer har
        presterat, och på vilket sätt aktiviteter skett osv. Härutöver behandlas
        en Kreatör som en användare.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <h4
        style={{
          paddingLeft: "150pt",
          textIndent: "-144pt",
          lineHeight: "110%",
          textAlign: "left",
        }}
      >
        Annonsör{" "}
        {/* <span className="s3">
          Vi samarbetar med digitala annonsörer för att tillhandahålla våra
          tjänster till dig. Digitala annonsörer använder sig av riktad,
          datadriven intelligens för att nå dig som potentiell konsument.
        </span> */}
      </h4>
      <p
        className="s3"
        style={{
          paddingLeft: "100pt",
          textIndent: "0pt",
          textAlign: "justify",
        }}
      >
        Vi samarbetar med digitala annonsörer för att tillhandahålla våra
        tjänster till dig. Digitala annonsörer använder sig av riktad,
        datadriven intelligens för att nå dig som potentiell konsument.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <h2
        style={{
          paddingLeft: "6pt",
          textIndent: "0pt",
          textAlign: "justify",
        }}
      >
        Vilka uppgifter behandlar vi om dig och varför?
      </h2>
      <p
        style={{
          paddingTop: "12pt",
          paddingLeft: "6pt",
          textIndent: "0pt",
          textAlign: "justify",
        }}
      >
        Nedan följer exempel på den typ av information som vi samlar in från dig
        och hur vi använder den informationen:
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "6.5pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "27pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
              bgcolor="#D9D9D9"
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                ÄNDAMÅL
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
              bgcolor="#D9D9D9"
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "4pt",
                  paddingRight: "5pt",
                  textIndent: "0pt",
                  lineHeight: "14pt",
                  textAlign: "left",
                }}
              >
                PERSONUPPGIFTE R
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
              bgcolor="#D9D9D9"
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                SYFTE
              </p>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
              bgcolor="#D9D9D9"
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                LAGLIG GRUND
              </p>
            </td>
          </tr>
          <tr style={{ height: "83pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "12pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Registrering av användarkonto
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
              rowSpan={2}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "4pt",
                  paddingRight: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Vi samlar in följande kontaktinformation när ett konto skapas:
              </p>
              <ul id="l1">
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "40pt",
                      textIndent: "-18pt",
                      textAlign: "left",
                    }}
                  >
                    namn
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "40pt",
                      paddingRight: "9pt",
                      textIndent: "-18pt",
                      textAlign: "left",
                    }}
                  >
                    användarnam n
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "40pt",
                      textIndent: "-18pt",
                      lineHeight: "14pt",
                      textAlign: "left",
                    }}
                  >
                    platsdata
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "40pt",
                      textIndent: "-18pt",
                      textAlign: "left",
                    }}
                  >
                    IP-adress
                  </p>
                </li>
              </ul>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "34pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Vi använder denna information för att tillhandahålla
                kontorelaterade funktioner till våra
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "13pt",
                  textAlign: "left",
                }}
              >
                användare.
              </p>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "14pt",
                  textAlign: "left",
                }}
              >
                Samtycke, Artikel 6.1
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                (a) GDPR
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Fullgörande av avtal, Artikel 6.1 (b) GDPR
              </p>
            </td>
          </tr>
          <tr style={{ height: "55pt" }}>
            <td
              style={{
                width: "93pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "3pt",
                  textIndent: "0pt",
                  lineHeight: "14pt",
                  textAlign: "left",
                }}
              >
                Konton, unikt identifieringsnummer (ID) kan användas för att
              </p>
            </td>
            <td
              style={{
                width: "120pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "13pt",
                  textAlign: "left",
                }}
              >
                Berättigat Intresse,
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Artikel 6.1 (f) GDPR
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "6.5pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "153pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
              rowSpan={3}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "4pt",
                  paddingRight: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Vi samlar också in information om de åtgärder som utförs när man
                är inloggad på sitt konto.
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "4pt",
                  paddingRight: "5pt",
                  textIndent: "0pt",
                  lineHeight: "14pt",
                  textAlign: "left",
                }}
              >
                Vi kopplar även samman personliga uppgifter till ett unikt
                identifieringsnummer (ID).
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "12pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                koppla samman användarens personuppgifter med deras
                interaktioner i appen, såsom inloggningar, preferenser och
                aktiviteter och för att kunna interagera med andra användare.
              </p>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
              rowSpan={3}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
          </tr>
          <tr style={{ height: "103pt" }}>
            <td
              style={{
                width: "116pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  lineHeight: "13pt",
                  textAlign: "left",
                }}
              >
                Platsdata och IP-adress
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                kan användas för att erbjuda lokala rekommendationer och
                erbjudande, förbättra säkerheten och förhindra bedrägeri.
              </p>
            </td>
          </tr>
          <tr style={{ height: "186pt" }}>
            <td
              style={{
                width: "116pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Åtgärderna hjälper oss att kunna verifiera användarens identitet
                vid inloggning samt skydda användarens konto och
                personuppgifter.
              </p>
            </td>
          </tr>
          <tr style={{ height: "104pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Registrering av användarkonto
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <ul id="l2">
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "11pt",
                      textIndent: "-7pt",
                      lineHeight: "14pt",
                      textAlign: "left",
                    }}
                  >
                    Födelsedatum
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "24pt",
                      textIndent: "-19pt",
                      textAlign: "left",
                    }}
                  >
                    Kön
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "4pt",
                      paddingRight: "5pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    Matpreferenser (ev?)
                  </p>
                </li>
              </ul>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "3pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Vi använder födelsedatum i första hand för att se till att
                användaren är myndig och för att anpassa innehållet för det fall
                användaren inte är det.
              </p>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Fullgörande av avtal, Artikel 6.1 (b) GDPR
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Berättigat Intresse, Artikel 6.1 (f) GDPR
              </p>
            </td>
          </tr>
          <tr style={{ height: "131pt" }}>
            <td
              style={{
                width: "93pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "5pt",
                  paddingRight: "3pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Vi använder födelsedatum, kön, matpreferenser och diet för att
                kunna erbjuda personanpassade rekommendationer baserat på denna
                information.
              </p>
            </td>
            <td
              style={{
                width: "120pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "6.5pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "539pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "7pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Vi använder marknadsundersökninga r som en grund till förståelse
                för vilken åldersgrupp och kön som interagerar med olika delar
                av appen och för att kunna erbjuda möjligheten till riktade
                annonser baserade på ålder, kön och matpreferenser.
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "12pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Information angående matpreferenser och dieter behandlar vi mot
                bakgrund av vårt berättigat intresse att kunna:
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <ul id="l3">
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "27pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    hjälpa användaren att hålla sig till sina preferenser och
                    diet
                  </p>
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "5pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    genom att föreslå recept som inte innehåller oönskade
                    ingredienser eller varna för recept som innehåller oönskade
                    ingredienser; och
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "6pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    ge användaren möjlighet att flagga ingredienser och
                    uppmärksamma andra användare i samband med delade recept.
                  </p>
                </li>
              </ul>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
          </tr>
          <tr style={{ height: "46pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Användar- och interaktionsdata
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "4pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                - Inköpslistor
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "31pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Vi behandlar denna information för att kunna:
              </p>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Fullgörande av avtal, Artikel 6.1 (b) GDPR
              </p>
            </td>
          </tr>
          <tr style={{ height: "106pt" }}>
            <td
              style={{
                width: "93pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingTop: "9pt",
                  paddingLeft: "5pt",
                  paddingRight: "7pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                - göra det enklare för användaren att veta vad de behöver köpa
                och för att underlätta planeringen av matinköp;
              </p>
            </td>
            <td
              style={{
                width: "120pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Berättigat Intresse, Artikel 6.1 (f) GDPR
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "6.5pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "441pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <ul id="l4">
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "6pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    använda inköpslistorna för att ge användaren personanpassade
                    rekommendationer och erbjudanden baserat på de ingredienser
                    och produkter som de har lagt till på sin inköpslista;
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "7pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    göra det möjligt att på sikt ge förslag på recept som kan
                    bidra till mer hållbar matkonsumtion.;
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "9pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    förbättra plattformens innehåll;
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "9pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    anpassa annonser efter vilka ingredienser och produkter som
                    användare interagerar med; och
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "7pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    erbjuda Annonsörer en förståelse för vilken målgrupp som
                    interagerar med deras annonser och livsmedel.
                  </p>
                </li>
              </ul>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
          </tr>
          <tr style={{ height: "104pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Användar- och interaktionsdata
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "4pt",
                  paddingRight: "6pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                - Sparade och uppladdade recept (inkl. ingredienser,
                instruktioner, ljudspår, bilder och betyg)
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "34pt",
                  textIndent: "0pt",
                  textAlign: "justify",
                }}
              >
                Vi använder denna information för att kunna:
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                -erbjuda användaren möjlighet att skapa och hålla koll på
                recept;
              </p>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Fullgörande av avtal, Artikel 6.1 (b) GDPR
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Berättigat Intresse, Artikel 6.1 (f) GDPR
              </p>
            </td>
          </tr>
          <tr style={{ height: "83pt" }}>
            <td
              style={{
                width: "93pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "5pt",
                  paddingRight: "12pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                -erbjuda personanpassade rekommendationer baserat på användarens
                sparade recept;
              </p>
            </td>
            <td
              style={{
                width: "120pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
          </tr>
          <tr style={{ height: "48pt" }}>
            <td
              style={{
                width: "93pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingTop: "5pt",
                  paddingLeft: "5pt",
                  paddingRight: "3pt",
                  textIndent: "0pt",
                  lineHeight: "14pt",
                  textAlign: "left",
                }}
              >
                - göra det enkelt för användare att hitta tillbaka till recept
                som
              </p>
            </td>
            <td
              style={{
                width: "120pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "6.5pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "456pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                användaren vill laga i framtiden;
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <ul id="l5">
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "6pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    göra det möjligt att dela recept med andra användare och
                    göra dem sökbara och tillgängliga;
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                  <p
                    className="s5"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "16pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    -
                    <span className="s4">förbättra plattformens innehåll;</span>
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "19pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    mäta ekologiskt fotavtryck (t. ex. CO2e-utsläpp) från
                    användarens middagsval; och
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "20pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    erbjuda Annonsörer förståelse för vilken målgrupp som
                    interagerar med deras recept.
                  </p>
                </li>
              </ul>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
          </tr>
          <tr style={{ height: "234pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Användar- och interaktionsdata
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <ul id="l6">
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "4pt",
                      paddingRight: "16pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    Events: Alla interaktioner som görs på plattformen (t. ex.
                    sidvisningar, sparade recept, knapptryckningar,
                    ’svajpningar’ och sökningar och därmed förenliga
                    interaktioner)
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "4pt",
                      paddingRight: "14pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    Enhetsdata (tillverkare, modell, operativsystem, webbläsare
                    osv.)
                  </p>
                </li>
              </ul>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "34pt",
                  textIndent: "0pt",
                  textAlign: "justify",
                }}
              >
                Vi använder denna information för att kunna:
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <ul id="l7">
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "13pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    förbättra användarupplevelsen genom att anpassa
                    rekommendationer baserat på användarens beteende;
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "10pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    utvärdera ändringar i appens gränssnitt och
                    rekommendationsmotor förbättrat användarupplevelsen;
                  </p>
                </li>
              </ul>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Fullgörande av avtal, Artikel 6.1 (b) GDPR
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Berättigat Intresse, Artikel 6.1 (f) GDPR
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "6.5pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "373pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <ul id="l8">
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "9pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    generera statistik och analyser om användares nyttjande av
                    plattformen;
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "7pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    kundanpassa annonser baserat på användarens beteende; och
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "7pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    erbjuda Annonsörer en förståelse om hur användare
                    interagerar med deras annonser, recept och livsmedel.
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "4pt",
                      textIndent: "0pt",
                      lineHeight: "14pt",
                      textAlign: "left",
                    }}
                  >
                    för att kunna identifiera användarens enheter och
                    aktiviteter på plattformen, för att felsöka, förbättra
                    säkerheten och förhindra bedrägeri, för att kunna erbjuda
                    användaren personaliserade inställningar och funktioner på
                    plattformen<span className="s5">.</span>
                  </p>
                </li>
              </ul>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
          </tr>
          <tr style={{ height: "179pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "10pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Användare som agerar som ’Kreatörer’
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "4pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Personnummer
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "34pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Vi använder denna information för:
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <ul id="l9">
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "6pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    att verifiera Kreatörens identitet;
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "9pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    att kunna följa lagkrav och göra
                  </p>
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "41pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    redovisningar till Skatteverket; och
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "12pt",
                      textIndent: "-7pt",
                      textAlign: "left",
                    }}
                  >
                    att upprätta avtal
                  </p>
                </li>
              </ul>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Fullgörande av avtal, Artikel 6.1 (b) GDPR
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Berättigat Intresse, Artikel 6.1 (f) GDPR
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "15pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Rättslig förpliktelse, Artikel 6.1 (c)
              </p>
            </td>
          </tr>
          <tr style={{ height: "124pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "10pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Användare som agerar som ’Kreatörer’
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "4pt",
                  paddingRight: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                -Namn, kontaktinformation och unikt identifieringsnummer
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Vi använder denna information för att:
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <ul id="l10">
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "18pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    verifiera Kreatörens identitet;
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "11pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    det ska gå att särskilja personer
                  </p>
                </li>
              </ul>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Fullgörande av avtal, Artikel 6.1 (b) GDPR Berättigat Intresse,
                Artikel 6.1 (f) GDPR
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "6.5pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "649pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <ul id="l11">
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "14pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    anpassa och förstärka användarupplevelsen;
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "19pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    ge Kreatören en mer personlig interaktion med plattformen
                    och andra användare på plattformen
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "17pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    användare ska kunna hitta Kreatörer på plattformen;
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "35pt",
                      textIndent: "0pt",
                      textAlign: "justify",
                    }}
                  >
                    hålla kontakt och kommunicera med Kreatören;
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "17pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    hålla reda på vilka Kreatörer som har erbjudits att synas på
                    plattformen;
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "7pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    skicka information och uppdateringar relaterade till
                    Kreatörens recept och aktiviteter på plattformen;
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "9pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    ge användare en möjlighet att hitta Kreatörens recept och
                    innehåll på plattformen;
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "12pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    möjliggöra funktioner för sociala medier, som följande och
                    gilla Kreatörens recept;
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "25pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    koppla samman användarens personuppgifter med deras
                    interaktioner i appen, såsom inloggningar och aktiviteter.
                  </p>
                </li>
              </ul>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
          </tr>
          <tr style={{ height: "41pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "6pt",
                  textIndent: "0pt",
                  lineHeight: "14pt",
                  textAlign: "left",
                }}
              >
                Kreatörers användar- och interaktions data
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "4pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                - <span className="s4">Uppladdade recept</span>
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "4pt",
                  paddingRight: "5pt",
                  textIndent: "0pt",
                  lineHeight: "14pt",
                  textAlign: "left",
                }}
              >
                (inkl. ingredienser, instruktioner,
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Vi använder denna information för att:
              </p>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Fullgörande av avtal, Artikel 6.1 (b) GDPR
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "6.5pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "235pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "4pt",
                  paddingRight: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                ljudspår, bilder och betyg)
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <ul id="l12">
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "10pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    visa Kreatörens recept och innehåll på plattformen;
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "5pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    ge användare möjlighet att söka, läsa och interagera med
                    Kreatörens recept; och
                  </p>
                  <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "6pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    ge Kreatören möjlighet att veta antalet visningar och andra
                    interaktioner med Kreatörens recept;
                  </p>
                </li>
              </ul>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Berättigat Intresse, Artikel 6.1 (f) GDPR
              </p>
            </td>
          </tr>
          <tr style={{ height: "179pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "12pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Administration av Kreatörer
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "4pt",
                  paddingRight: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                - Löne- och skatteuppgifter
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Vi använder informationen för att kunna:
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <ul id="l13">
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "20pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    utfärda löneutbetalningar och följa lagkrav; och
                  </p>
                </li>
                <li data-list-text="-">
                  <p
                    className="s4"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "11pt",
                      textIndent: "0pt",
                      textAlign: "left",
                    }}
                  >
                    göra redovisningar till Skatteverket.
                  </p>
                </li>
              </ul>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Fullgörande av avtal, Artikel 6.1 (b) GDPR
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Berättigat Intresse, Artikel 6.1 (f) GDPR
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "15pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Rättslig förpliktelse, Artikel 6.1 (c)
              </p>
            </td>
          </tr>
          <tr style={{ height: "21pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
          </tr>
          <tr style={{ height: "115pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Marknadsunders ökningar
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "4pt",
                  paddingRight: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Enkät- och intervjusvar
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "12pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Vi använder informationen för att kunna utveckla och förbättra
                våra produkter.
              </p>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Fullgörande av avtal, Artikel 6.1 (b) GDPR
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left",
                }}
              >
                Berättigat Intresse, Artikel 6.1 (f) GDPR
              </p>
            </td>
          </tr>
          <tr style={{ height: "15pt" }}>
            <td
              style={{
                width: "93pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "116pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "131pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
            <td
              style={{
                width: "120pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
              }}
            >
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <h2
        style={{
          paddingTop: "4pt",
          paddingLeft: "6pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Rättslig grund för behandling
      </h2>
      <p style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
        Rättslig grund kan variera beroende på vilket syftet med
        personuppgiftsbehandlingen är, och kan vara en eller mer av den följande
        baserad på GDPR Art. 6:
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <ul id="l14">
        <li data-list-text="-">
          <p
            style={{
              paddingLeft: "13pt",
              textIndent: "-7pt",
              textAlign: "left",
            }}
          >
            ditt samtycke (GDPR 6.1 (a))
          </p>
        </li>
        <li data-list-text="-">
          <p
            style={{
              paddingLeft: "13pt",
              textIndent: "-7pt",
              textAlign: "left",
            }}
          >
            för att fullgöra avtal med dig, tillvarata rättsliga förpliktelser:
            (GDPR art. 6.1 (b));
          </p>
        </li>
        <li data-list-text="-">
          <p
            style={{
              paddingTop: "3pt",
              paddingLeft: "13pt",
              textIndent: "-7pt",
              textAlign: "justify",
            }}
          >
            för andra berättigade intressen, såsom marknadsföring (GDPR art. 6.1
            (f))
          </p>
          <h2
            style={{
              paddingTop: "9pt",
              paddingLeft: "6pt",
              textIndent: "0pt",
              textAlign: "left",
            }}
          >
            Hur länge sparar vi dina uppgifter?
          </h2>
          <p
            style={{
              paddingLeft: "6pt",
              textIndent: "0pt",
              textAlign: "justify",
            }}
          >
            Vi sparar dina personuppgifter så länge de är nödvändiga för att
            uppfylla det angivna ändamålet, exempelvis för att uppfylla ett
            lagkrav, därefter tas uppgifterna bort eller avidentifieras.
          </p>
          <h2
            style={{
              paddingTop: "9pt",
              paddingLeft: "6pt",
              textIndent: "0pt",
              textAlign: "left",
            }}
          >
            Med vem delar vi dina uppgifter?
          </h2>
          <p
            style={{
              paddingLeft: "6pt",
              textIndent: "0pt",
              lineHeight: "108%",
              textAlign: "justify",
            }}
          >
            Vi kan komma att lämna ut dina personuppgifter till tredje part,
            såsom tjänsteleverantörer, IT-leverantörer och företag som vi
            samarbetar med för att tillhandahålla våra tjänster, såsom olika
            marknadsföringsbyråer som hjälper oss med vår kommunikation och våra
            erbjudanden till dig, samarbetspartners som kan komma att bistå oss
            vid hantering av kund- och ramavtalspartners i de fall du omfattas
            av de ramavtal vi ingått. Vi kan i vissa fall också behöva lämna ut
            uppgifter på begäran av myndigheter eller till andra parter inom
            ramen för domstols- eller företagsförvärvsprocesser eller liknande.
            Vi kommer aldrig att sälja dina personuppgifter till någon.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <h2
            style={{
              paddingLeft: "6pt",
              textIndent: "0pt",
              textAlign: "left",
            }}
          >
            Var behandlar vi dina uppgifter?
          </h2>
          <p
            style={{
              paddingLeft: "6pt",
              textIndent: "0pt",
              textAlign: "left",
            }}
          >
            Vi strävar alltid efter att behandla dina personuppgifter inom
            EU/EES. I vissa situationer, såsom när vi delar din information med
            till exempel en IT-leverantör med verksamhet utanför EU/EES, kan
            dina personuppgifter dock komma att behandlas utanför EU/EES. Om och
            när dina uppgifter behandlas utanför EU/EES säkerställer vi att det
            föreligger en adekvat skyddsnivå och att lämpliga skyddsåtgärder
            vidtas (till exempel genom användning av
          </p>
          <p
            style={{
              paddingLeft: "6pt",
              textIndent: "0pt",
              textAlign: "left",
            }}
          >
            EU-kommissionens standardavtalsklausuler).
          </p>
          <h2
            style={{
              paddingTop: "9pt",
              paddingLeft: "6pt",
              textIndent: "0pt",
              textAlign: "left",
            }}
          >
            Dina rättigheter som registrerad
          </h2>
          <p
            style={{
              paddingLeft: "6pt",
              textIndent: "0pt",
              textAlign: "left",
            }}
          >
            <a href="mailto:privacy@kurr.co" className="a" target="_blank">
              Som registrerad har du vissa rättigheter i förhållande till
              behandling av dina personuppgifter. Om du vill utöva någon av dem,
              vänligen kontakta oss via{" "}
            </a>
            <a href="mailto:privacy@kurr.co" target="_blank">
              privacy@kurr.co
            </a>
          </p>
          <p
            style={{
              paddingLeft: "6pt",
              textIndent: "0pt",
              textAlign: "left",
            }}
          >
            .
          </p>
          <ul id="l15">
            <li data-list-text="●">
              <p
                style={{
                  paddingLeft: "42pt",
                  textIndent: "0pt",
                  textAlign: "justify",
                }}
              >
                Rätt till tillgång: Du har rätt att få information om vilka
                personuppgifter vi behandlar om dig, inklusive ändamålet för
                behandlingen samt den rättsliga grunden för behandlingen.
              </p>
            </li>
            <li data-list-text="●">
              <p
                style={{
                  paddingLeft: "42pt",
                  textIndent: "0pt",
                  textAlign: "justify",
                }}
              >
                Rätt till korrigering/rättelse: Om du anser att vi behandlar
                felaktiga personuppgifter om dig kan du be oss om att rätta till
                dem.
              </p>
            </li>
            <li data-list-text="●">
              <p
                style={{
                  paddingLeft: "42pt",
                  textIndent: "0pt",
                  textAlign: "justify",
                }}
              >
                Rätt till begränsning av behandlingen: Du kan begära att vi
                begränsar behandlingen av dina personuppgifter. Det kan till
                exempel vara relevant om vi har felaktiga uppgifter om dig och
                du inte vill att behandlingen ska fortsätta förrän vi har rättat
                uppgifterna.
              </p>
            </li>
            <li data-list-text="●">
              <p
                style={{
                  paddingLeft: "42pt",
                  textIndent: "0pt",
                  textAlign: "justify",
                }}
              >
                Rätt till radering / rätt att glömmas bort: Du kan begära att vi
                tar bort dina personuppgifter. Även om vi kommer att tillmötesgå
                en sådan begäran i den utsträckning som krävs enligt gällande
                lag, vänligen notera att vi trots din begäran kan komma att
                fortsätta behandlingen av vissa uppgifter (såsom uppgifter som
                vi behöver behålla för att skydda våra rättsliga intressen eller
                som vi enligt lag är skyldiga att bevara).
              </p>
            </li>
            <li data-list-text="●">
              <p
                style={{
                  paddingLeft: "42pt",
                  textIndent: "0pt",
                  textAlign: "justify",
                }}
              >
                Rätt att invända: I samband med behandling av personuppgifter
                baserat på berättigat intresse har du rätt att invända mot
                användningen av dina
              </p>
              <p
                style={{
                  paddingTop: "3pt",
                  paddingLeft: "42pt",
                  textIndent: "0pt",
                  textAlign: "justify",
                }}
              >
                personuppgifter. Om dina integritetsintressen uppväger våra
                intressen för att behandla vissa data, kommer vi att sluta
                behandla sådana uppgifter.
              </p>
            </li>
            <li data-list-text="●">
              <p
                style={{
                  paddingLeft: "42pt",
                  textIndent: "0pt",
                  textAlign: "justify",
                }}
              >
                Rätt till dataportabilitet: Du kan även ha rätt att få tillgång
                till de personuppgifter som du har tillhandahållit oss i ett
                strukturerat, allmänt accepterat och maskinläsbart format, samt
                rätt att överföra uppgifterna till en annan
                personuppgiftsansvarig.
              </p>
            </li>
          </ul>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <h2 style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
        Vill du veta mer?
      </h2>
      <p style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
        <a href="mailto:privacy@kurr.co" className="a" target="_blank">
          Om du har några frågor om vår behandling av dina personuppgifter,
          vänligen inte tveka att kontakta oss via{" "}
        </a>
        <a href="mailto:privacy@kurr.co" target="_blank">
          privacy@kurr.co.
        </a>
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <h2 style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
        Om du inte är nöjd med oss
      </h2>
      <p style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
        <a href="mailto:privacy@kurr.co" className="a" target="_blank">
          Om du inte är nöjd med hur vi behandlar dina personuppgifter är du
          välkommen att kontakta vårt dataskyddsombud via{" "}
        </a>
        <a href="http://www.imy.se/" className="a" target="_blank">
          privacy@kurr.co. Du kan också kontakta den svenska
          dataskyddsmyndigheten (Integritetsskyddsmyndigheten,{" "}
        </a>
        www.imy.se, imy@imy.se).
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "6pt", textIndent: "0pt", textAlign: "left" }}>
        Denna information gäller från och med den 2023-03-08
      </p>
    </div>
  );
};

export default PrivacyPolicy;

// import React, { useState, useEffect } from "react";
// import privacyPolicyPDF from "../../shared/assets/Integritetspolicy.html";

// const HtmlComponent = () => {
//   const [htmlContent, setHtmlContent] = useState("");

//   useEffect(() => {
//     fetch("src/shared/assets/Integritetspolicy.html")
//       .then((response) => response.text())
//       .then((data) => {
//         setHtmlContent(data);
//       });
//   }, []);

//   return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
// };

// export default HtmlComponent;

// import { useState } from "react";
// import { Document, Page } from "react-pdf";
// import privacyPolicyPDF from "../../shared/assets/Kurr_Integritetspolicy.docx";

// export default function PrivacyPolicy() {
//   const [numPages, setNumPages] = useState(null);

//   function onDocumentLoadSuccess({ numPages }) {
//     setNumPages(numPages);
//   }

//   return (
//     <div>
//       <Document file={privacyPolicyPDF} onLoadSuccess={onDocumentLoadSuccess}>
//         {Array.from(new Array(numPages), (el, index) => (
//           <Page key={`page_${index + 1}`} pageNumber={index + 1} />
//         ))}
//         <Page pageNumber={2} />
//       </Document>
//     </div>
//   );
// }

// import React, { useState } from "react";
// import { Document, Page } from "react-pdf";

// export default function PrivacyPolicy() {
//   const [numPages, setNumPages] = useState(null);

//   function onDocumentLoadSuccess({ numPages }) {
//     setNumPages(numPages);
//   }

//   return (
//     <div>
//       <Document
//         file="https://kurr-document-bucket.s3.eu-north-1.amazonaws.com/Integritetspolicy.pdf"
//         onLoadSuccess={onDocumentLoadSuccess}
//       >
//         {Array.from(new Array(numPages), (el, index) => (
//           <Page key={`page_${index + 1}`} pageNumber={index + 1} />
//         ))}
//       </Document>
//     </div>
//   );
// }
